import React from 'react';
const blocks = [{
  name: 'Warm-up',
  min: 10,
  color: 'bg-white/25',
  text: 'text-white'
}, {
  name: 'Conditioning',
  min: 10,
  color: 'bg-amber',
  text: 'text-ink'
}, {
  name: 'Skill',
  min: 25,
  color: 'bg-coral',
  text: 'text-white'
}, {
  name: 'Sequence + cool-down',
  min: 15,
  color: 'bg-teal',
  text: 'text-white'
}];
const coverage = [{
  label: 'Flight Path Ladders',
  body: 'Every skill on silks, hoop and trapeze as a ladder of rungs, from first grip to first combo — you always know what comes next'
}, {
  label: 'Class Plan',
  body: 'The whole class on one page: pre-flight check, warm-up, conditioning, the skill with cues, the sequence and the cool-down'
}, {
  label: '45 · 60 · 75 minutes',
  body: 'Same four blocks, the minutes already worked out for your slot'
}, {
  label: 'One rig, many students',
  body: 'Rotation plans keep the floor group working while one student is up on the fabric, the hoop or the bar'
}, {
  label: 'Mixed-level option',
  body: 'Easier, target and harder on every skill, so three levels work the same class'
}, {
  label: 'Pre-Flight & spotting',
  body: 'A rig and safety check on every plan, where to stand, and when to refer out — within your professional scope'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full bg-ink text-white" data-id="element-239" data-mp="1jvcabjqmuc1d">
      <div className="apparatus-strip h-1.5 w-full" aria-hidden="true" data-id="element-240" data-mp="1orkjmgi5fb0m" />
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-241" data-mp="s34rqdrkgpkc">
        <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-amber" data-id="element-242" data-mp="w359o8dvjiw5">The system</p>
        <h2 id="mechanism-heading" className="mt-3 font-display text-3xl font-extrabold text-white sm:text-5xl" data-id="element-243" data-mp="1128dxqm15l32">
          The Flight Path System
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-white/80 sm:text-lg" data-id="element-244" data-mp="15zrskrmn3zvj">
          Lesson plans aren&apos;t new. Plans you can actually walk in and teach
          are. A blank planner leaves you to fill in the class; a list of tricks
          leaves you to build it. Here every skill has a{' '}
          <span className="font-semibold text-white" data-id="element-245" data-mp="1rup4q0dw63t6">Flight Path</span> — a ladder of
          prerequisites from first grip to first sequence — and every class comes
          as a <span className="font-semibold text-white" data-id="element-246" data-mp="21qjs18t28n2a">Class Plan</span> you run as
          written. Pick the rung, open the plan, teach.
        </p>

        <div className="mx-auto mt-9 max-w-3xl text-left" data-id="element-247" data-mp="1924njg7k1n57">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-white/60" data-id="element-248" data-mp="192nz8f6m3fas">A 60-minute class · The 4-Block Session Formula</p>
          <div className="mt-2 flex h-11 w-full overflow-hidden rounded-xl border border-ink-line" data-id="element-249" data-mp="1ispkkz7kyjm0">
            {blocks.map(b => <div key={b.name} style={{
            flexGrow: b.min,
            flexBasis: 0
          }} className={`${b.color} ${b.text} flex items-center justify-center font-display text-sm font-bold sm:text-base`} data-id="element-250" data-mp="1e0phixw7ral7">
                {b.min}′
              </div>)}
          </div>
          <ol className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1.5 text-[12.5px] text-white/75 sm:grid-cols-4" data-id="element-251" data-mp="2wy2g7k0d498z">
            {blocks.map((b, i) => <li key={b.name} className="flex items-center gap-1.5" data-id="element-252" data-mp="2n2r0ozh4qy06" data-mpi={i}>
                <span className={`h-2.5 w-2.5 flex-none rounded-sm ${b.color}`} data-id="element-253" data-mp="2s12bbcf91cjg" />
                {i + 1}. {b.name}
              </li>)}
          </ol>
        </div>

        <ul className="mt-10 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-254" data-mp="3fok5tfpweoq4">
          {coverage.map(item => <li key={item.label} className="rounded-xl border border-ink-line bg-white/5 px-4 py-3" data-id="element-255" data-mp="36pyr5vnjrtum">
              <span className="block text-[11px] font-semibold uppercase tracking-widest text-amber" data-id="element-256" data-mp="3ark2vdoci238">{item.label}</span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-257" data-mp="1vajw4xewfc25">{item.body}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}